<template>
  <div style="margin-top: 30px">
    <div style="text-align: center">
      <b-badge
        class="btn"
        variant="info"
        style="
          font-size: 16px;
          background-color: #1779cc !important;
          color: #ffffff;
        "
        @click="open"
        >{{ isxianshi ? "隐藏筛选项" : "显示筛选项" }}</b-badge
      >
    </div>
    <div class="11" v-if="isxianshi">
      <div class="form-group col-md-6 mb-3">
        <label for="input-1">载体类型</label>
        <b-form-select
          v-model="query.ParkType"
          :options="options1"
          @change="change"
          id="inline-form-custom-select-pref1"
        ></b-form-select>
      </div>

      <b-form-group
        class="col-md-12 mb-3"
        label="剩余面积大于"
        label-for="input-1"
      >
        <b-form-input
          v-model="query.symjdy"
          type="text"
          placeholder=""
        ></b-form-input>
        <b-form-select
          v-model="query.danWeiSY"
          :options="options4"
          id="inline-form-custom-select-pref1"
        ></b-form-select>
      </b-form-group>

      <div style="display: flex">
        <b-form-group class="col-md-2 mb-3">
          <b-button variant="primary ripple btn-icon m-1 ser" @click="search"
            >查询</b-button
          >
        </b-form-group>

        <b-form-group class="col-md-2 mb-3" style="margin-left: -80px">
          <b-button
            variant="primary ripple btn-icon m-1 ser"
            @click="changetype"
            >{{ isweixing ? "切换普通地图" : "切换卫星地图" }}</b-button
          >
        </b-form-group>
      </div>
    </div>
    <baidu-map
      :map-type="type"
      class="bm-view"
      @ready="handler"
      @zoomend="zoomEnd"
      :center="{ lng: 106.521143, lat: 29.515448 }"
      :zoom="zoom"
      :scroll-wheel-zoom="true"
    >
      <bm-boundary
        fillColor=""
        :fillOpacity="0.1"
        name="重庆市九龙坡区"
        :strokeWeight="6"
        strokeColor="yellow"
      ></bm-boundary>
      <!-- 坐标点 -->
      <div v-if="markers.length > 0 && maptype">
        <div v-for="(item, index) in markers" :key="index">
          <bm-marker
            :position="item.point"
            :title="item.name"
            :dragging="false"
          >
            <my-overlay
              v-if="show"
              :position="item.point"
              :text="item.name"
              :text2="item.remaining"
              :danWei="item.danWei"
              :active="active"
              @mouseover.native="active = true"
              @mouseleave.native="active = false"
            >
            </my-overlay>
          </bm-marker>
        </div>
      </div>
      <!-- 载体地图区域 -->
      <div v-if="polygonPath.length > 0 && maptype">
        <div v-for="(item, index) in polygonPath" :key="index">
          <bm-polygon
            :title="item.name"
            :path="item.point"
            stroke-color="red"
            :stroke-opacity="0.5"
            :stroke-weight="2"
            :clicking="true"
            @mouseover="detail(item)"
          >
          </bm-polygon>
        </div>
      </div>

      <!-- 四轮驱动地图点 -->
      <div v-for="(item, index) in markers2" :key="'mk2'+index">
        <bm-marker :position="item.point" :title="item.name" :dragging="false">
          <my-overlay2
            :isweixing="isweixing"
            :position="item.point"
            :text="item.name"
            @mouseover.native="active = true"
            @mouseleave.native="active = false"
          >
          </my-overlay2>
        </bm-marker>
      </div>

      <!-- 四轮驱动区域 -->
      <div v-for="(item, index) in fourPath" :key="index" class="info">
        <bm-polygon
          :fillOpacity="0.1"
          :fillColor="item.bgcolor"
          :title="item.name"
          :path="item.point"
          :stroke-opacity="1"
          :stroke-weight="2"
          :clicking="true"
        >
        </bm-polygon>
      </div>
    </baidu-map>
  </div>
</template>
<script>
// import * as api from "@/api/resource";
import MyOverlay from "./MyOverlay.vue";
import MyOverlay2 from "./MyOverlay2.vue";
import { meishu, xinshangquan, gaotie, xibu } from "./pointarr";
export default {
  components: {
    MyOverlay,
    MyOverlay2,
  },
  created() {
    this.$nextTick(() => {
      this.getzaitidata();
    });
  },
  data() {
    return {
      maptype: true,
      active: false,
      url: require("@/assets/imgs/map.gif"),
      type: "BMAP_HYBRID_MAP",
      isweixing: true,
      isxianshi: false,
      options4: [
        { value: "亩", text: "亩" },
        { value: "万平方米", text: "万平方米" },
      ],
      options1: [
        { value: "", text: "请选择" },
        { value: 0, text: "工业用地" },
        { value: 100, text: "工业厂房" },
        { value: 200, text: "楼宇" },
        { value: 300, text: "其它" },
      ],
      query: {
        total: 100,
        PageSize: 10000,
        PageIndex: 1,
        //载体名称
        ParkName: "",
        //载体类型
        ParkType: "",
        //所在地
        Location: "",
        //详细地址
        Address: "",
        symjdy: "0",
        danWeiSY: "万平方米",
      },
      show: false,
      center: { lng: 0, lat: 0 },
      zoom: 15,
      map: null,
      overlays: [], //划定区域坐标点
      markers: [],
      markers2: [
        {
          name: "九龙美术半岛",
          point: {
            lat: 29.498914,
            lng: 106.539594,
          },
        },
        {
          name: "九龙新商圈",
          point: {
            lat: 29.524185,
            lng: 106.510112,
          },
        },
        {
          name: "高铁临港经济区",
          point: {
            lat: 29.472474,
            lng: 106.440358,
          },
        },
        {
          name: "西部(重庆)科学城九龙坡片区",
          point: {
            lat: 29.347627,
            lng: 106.346431,
          },
        },
      ], //四轮驱动点
      arr: [],
      polygonPath: [],
      fourPath: [
        {
          name: "九龙美术半岛",
          bgcolor: "#EDAF1F",
          point: meishu,
        },
        {
          name: "九龙新商圈",
          bgcolor: "#00AA00",
          point: xinshangquan,
        },
        {
          name: "高铁临港经济区",
          bgcolor: "#0000FF",
          point: gaotie,
        },
        {
          name: "西部(重庆)科学城九龙坡片区",
          bgcolor: "#F69293",
          point: xibu,
        },
      ], //四轮驱动地图的区域坐标数组
    };
  },
  methods: {
    search() {
      this.getzaitidata();
      this.isxianshi = false;
    },
    open() {
      this.isxianshi = !this.isxianshi;
    },
    zoomEnd(e) {
      console.log(e);
      this.zoom = e.target.getZoom();
      console.log(this.zoom, "zoom");
      if (this.zoom >= 15) {
        //显示标签
        this.show = true;
      } else {
        this.show = false;
      }
    },
    getzaitidata() {
      this.markers = [];
      this.polygonPath = [];
      this.request({
        url: "/v1.0/Library/getParkPagedList",
        method: "GET",
        params: this.query,
      }).then((res) => {
        let arr = [];
        res.data.items.forEach((item) => {
          let obj = {
            name: "",
            remaining: "",
            point: {
              lat: "",
              lng: "",
            },
          };
          obj.name = item.parkName;
          obj.remaining = item.remaining;
          obj.danWei = item.danWei;
          obj.showFlag = false;
          if (item.pointX && item.pointX.length > 15) {
            //区域
            let yobj = {
              name: item.parkName,
              point: [],
              showFlag2: false,
              remaining: item.remaining,
            };
            let xrr = item.pointY.split(",");
            let yrr = item.pointX.split(",");
            for (var i = 0; i < xrr.length; i++) {
              let obj = {};
              obj.lng = xrr[i];
              obj.lat = yrr[i];
              yobj.point.push(obj);
            }
            this.polygonPath.push(yobj);
            console.log(this.polygonPath, 111111111);
            //把区域的第一个坐标拿出来放到点里面去
            //取x轴最大值加最小值/2
            let add = Number(xrr.max()) + Number(xrr.min());
            let add2 = add.toFixed(6);
            //取y轴最大值加最小值/2
            let ydd = Number(yrr.max()) + Number(yrr.min());
            let ydd2 = ydd.toFixed(6);
            console.log(ydd2 / 2, 855);
            let obj3 = {
              danWei: item.danWei,
              name: item.parkName,
              remaining: item.remaining,
              point: {
                lat: ydd2 / 2,
                lng: add2 / 2,
              },
              showFlag: true,
            };
            arr.push(obj3);
          } else {
            if (item.pointX) {
              obj.point.lat = item.pointX;
            }
            if (item.pointY) {
              obj.point.lng = item.pointY;
            }
            arr.push(obj);
          }
        });
        this.markers = arr;
        console.log(this.markers, "yjc");
      });
    },
    lookDetail(marker) {
      marker.showFlag = true;
      this.infoWindow.info = marker;
    },
    addressclick(item) {
      item.showFlag = true;
      console.log(item, 5555);
    },
    // removeaddress(item) {
    //   console.log(item, 4444);
    //   item.showFlag = false;
    // },
    change(e) {
      this.query.ParkType = e;
      if (e == 0 || e == 300) {
        this.query.danWeiSY = "亩";
      } else {
        this.query.danWeiSY = "万平方米";
      }
    },
    changetype() {
      this.isweixing = !this.isweixing;
      this.isweixing
        ? (this.type = "BMAP_HYBRID_MAP")
        : (this.type = "BMAP_NORMAL_MAP");
      this.isxianshi = false;
    },
    lab(item) {
      console.log(item, 6633);
    },
    handler({ BMap, map }) {
      // this.point = new BMap.Point(106.513746, 29.526533);
      // map.centerAndZoom(this.point, 12);
      this.bMap = BMap;
      this.sMap = map;
    },

    close(item) {
      item.showFlag = false;
    },
  },
};
</script>
<style>
.bm-view {
  height: 95vh;
  width: 100%;
}
.btn {
  margin-bottom: 10px;
  margin: 10 auto;
}
</style>